/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { ConfigGroupsSelect_ConfigFragmentDoc, ConfigGroupsSelect_GroupFragmentDoc } from '../../../__generated__/ConfigGroupSelect.graphql';
import { ConfigGroupsSelect_CustomerFragmentDoc } from '../../../__generated__/ConfigGroupSelect.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigInlineGroupsSelect_ConfigFragment = { __typename: 'ConfigurationModel', id: string, groups: Array<{ __typename: 'Group', id: string, name: string }> };

export type ConfigInlineGroupsSelect_CustomerFragment = { __typename: 'Customer', id: string, groups: Array<{ __typename: 'Group', id: string, name: string }> };

export type ConfigInlineGrouppsSelect_GroupCreateMutationVariables = Types.Exact<{
  input: Types.GroupCreateInput;
}>;


export type ConfigInlineGrouppsSelect_GroupCreateMutation = { __typename: 'Mutation', groupCreate: { __typename: 'GroupCreatePayload', group?: { __typename: 'Group', id: string, name: string } | null, customer?: { __typename: 'Customer', id: string, groups: Array<{ __typename: 'Group', id: string, name: string }> } | null } };

export type ConfigAddGroupMutationVariables = Types.Exact<{
  input: Types.ConfigurationAddGroupInput;
}>;


export type ConfigAddGroupMutation = { __typename: 'Mutation', configurationAddGroup: { __typename: 'ConfigurationModel', id: string, groups: Array<{ __typename: 'Group', id: string, name: string }> } };

export type ConfigDeleteGroupMutationVariables = Types.Exact<{
  input: Types.ConfigurationDeleteGroupInput;
}>;


export type ConfigDeleteGroupMutation = { __typename: 'Mutation', configurationDeleteGroup: { __typename: 'ConfigurationModel', id: string, groups: Array<{ __typename: 'Group', id: string, name: string }> } };

export const ConfigInlineGroupsSelect_ConfigFragmentDoc = gql`
    fragment ConfigInlineGroupsSelect_config on ConfigurationModel {
  id
  ...ConfigGroupsSelect_config
  groups {
    id
    ...ConfigGroupsSelect_group
  }
}
    ${ConfigGroupsSelect_ConfigFragmentDoc}
${ConfigGroupsSelect_GroupFragmentDoc}`;
export const ConfigInlineGroupsSelect_CustomerFragmentDoc = gql`
    fragment ConfigInlineGroupsSelect_customer on Customer {
  id
  ...ConfigGroupsSelect_customer
}
    ${ConfigGroupsSelect_CustomerFragmentDoc}`;
export const ConfigInlineGrouppsSelect_GroupCreateDocument = gql`
    mutation ConfigInlineGrouppsSelect_GroupCreate($input: GroupCreateInput!) {
  groupCreate(input: $input) {
    group {
      id
      name
    }
    customer {
      id
      groups {
        id
        name
      }
    }
  }
}
    `;
export type ConfigInlineGrouppsSelect_GroupCreateMutationFn = ApolloReactCommon.MutationFunction<ConfigInlineGrouppsSelect_GroupCreateMutation, ConfigInlineGrouppsSelect_GroupCreateMutationVariables>;

/**
 * __useConfigInlineGrouppsSelect_GroupCreateMutation__
 *
 * To run a mutation, you first call `useConfigInlineGrouppsSelect_GroupCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigInlineGrouppsSelect_GroupCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configInlineGrouppsSelectGroupCreateMutation, { data, loading, error }] = useConfigInlineGrouppsSelect_GroupCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigInlineGrouppsSelect_GroupCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigInlineGrouppsSelect_GroupCreateMutation, ConfigInlineGrouppsSelect_GroupCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigInlineGrouppsSelect_GroupCreateMutation, ConfigInlineGrouppsSelect_GroupCreateMutationVariables>(ConfigInlineGrouppsSelect_GroupCreateDocument, options);
      }
export type ConfigInlineGrouppsSelect_GroupCreateMutationHookResult = ReturnType<typeof useConfigInlineGrouppsSelect_GroupCreateMutation>;
export type ConfigInlineGrouppsSelect_GroupCreateMutationResult = ApolloReactCommon.MutationResult<ConfigInlineGrouppsSelect_GroupCreateMutation>;
export type ConfigInlineGrouppsSelect_GroupCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigInlineGrouppsSelect_GroupCreateMutation, ConfigInlineGrouppsSelect_GroupCreateMutationVariables>;
export const ConfigAddGroupDocument = gql`
    mutation ConfigAddGroup($input: ConfigurationAddGroupInput!) {
  configurationAddGroup(input: $input) {
    id
    groups {
      id
      name
    }
  }
}
    `;
export type ConfigAddGroupMutationFn = ApolloReactCommon.MutationFunction<ConfigAddGroupMutation, ConfigAddGroupMutationVariables>;

/**
 * __useConfigAddGroupMutation__
 *
 * To run a mutation, you first call `useConfigAddGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigAddGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configAddGroupMutation, { data, loading, error }] = useConfigAddGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigAddGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigAddGroupMutation, ConfigAddGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigAddGroupMutation, ConfigAddGroupMutationVariables>(ConfigAddGroupDocument, options);
      }
export type ConfigAddGroupMutationHookResult = ReturnType<typeof useConfigAddGroupMutation>;
export type ConfigAddGroupMutationResult = ApolloReactCommon.MutationResult<ConfigAddGroupMutation>;
export type ConfigAddGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigAddGroupMutation, ConfigAddGroupMutationVariables>;
export const ConfigDeleteGroupDocument = gql`
    mutation ConfigDeleteGroup($input: ConfigurationDeleteGroupInput!) {
  configurationDeleteGroup(input: $input) {
    id
    groups {
      id
      name
    }
  }
}
    `;
export type ConfigDeleteGroupMutationFn = ApolloReactCommon.MutationFunction<ConfigDeleteGroupMutation, ConfigDeleteGroupMutationVariables>;

/**
 * __useConfigDeleteGroupMutation__
 *
 * To run a mutation, you first call `useConfigDeleteGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigDeleteGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configDeleteGroupMutation, { data, loading, error }] = useConfigDeleteGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigDeleteGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigDeleteGroupMutation, ConfigDeleteGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigDeleteGroupMutation, ConfigDeleteGroupMutationVariables>(ConfigDeleteGroupDocument, options);
      }
export type ConfigDeleteGroupMutationHookResult = ReturnType<typeof useConfigDeleteGroupMutation>;
export type ConfigDeleteGroupMutationResult = ApolloReactCommon.MutationResult<ConfigDeleteGroupMutation>;
export type ConfigDeleteGroupMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigDeleteGroupMutation, ConfigDeleteGroupMutationVariables>;